import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CallConnectionSummaryService {

  constructor(private http: HttpClient) { }

  ur1 = environment.serverAPI9 + "/api/callConnection";


  ur2 = environment.serverAPI9 + "/api/lead/connectedcalls";


  searchCallConnectionSummary(query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {
    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy
    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.ur1}/condition/${queryParams}`, requestBody);
  }

  searchCallConnectionGlobal(query: string): Observable<any> {
    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null
    };
    return this.http.post<any>(`${environment.serverAPI9}/api/callConnectionGlobal/condition`, requestBody);
  }

  getConnectedCallsId(entityId: number): Observable<Object> {
  return this.http.post(`${this.ur2}/${entityId}`, {}); 
}

}
